import React from 'react';

import Loader from '../../../../assets/images/spinner-DNA-2s-200px.svg';

function LoadingSearchIndicator() {
  return (
    <div className="loading-container">
      <img alt="loader" src={Loader} />
    </div>
  );
}

export default LoadingSearchIndicator;
